<template lang="pug" src="./List.pug">

</template>
<script>

import { mapActions } from 'vuex'
import { buildPayloadPagination } from '@/utils/utils.js'

  export default{
    data: () => ({
      fee: 0.1148,
      search: '',
      bucket: process.env.VUE_APP_S3_BUCKET,
      imgPath: "https://"+process.env.VUE_APP_S3_BUCKET,
      publicPath: process.env.BASE_URL,
      showInactive: false,
      delConfirm: false,
      giftId: '',
      giftName: '',
      giftImage: '',
      pagination: {
        sortBy: ['createdAt'],
        sortDesc: ['true']
      },
      initialized: false
    }),

    computed: {

      headers(){
        return [
          { text: 'Imagem', value: 'image' },
          { text: 'Categoria', value: 'category' },
          { text: 'Nome', value: 'title' },
          { text: 'Preço promotora', value: 'priceNet' },
          { text: 'Preço final', value: 'priceGross' },
          { text: 'Rifas', value: 'raffle' },
          { text: 'Limite', value: 'limit' },
          { text: 'Lista', value: 'plan' },
          { text: 'Ações', value: 'actions' }
        ]
      },
      gifts(){
        const array = this.$store.state.gifts.gifts || []
        const filtered = array.filter(g => g && (this.showInactive ? g.active === false : g.active === true))
        return filtered
          .slice()
          .sort((a, b) => {
            const ac = String(a.category || '')
            const bc = String(b.category || '')
            return ac.localeCompare(bc, 'pt-BR', { sensitivity: 'base' })
          })
      },
      totalGifts(){
        const list = this.gifts
        return Array.isArray(list) ? list.length : 0
      }
    },

    methods: {
      ...mapActions([ 'getGifts', 'deleteGift' ]),

      grossWithFee(v) {
        const result = v / (1 - this.fee)
        return Math.ceil(result * 100) / 100
      },

      deleteConfirm(item){
        this.giftName = item.title
        this.giftId = item.id
        this.giftImage = item.image
        this.delConfirm = true
      },
      async delGift(id){
        this.delConfirm = false
        await this.deleteGift({ _id: id })
        this.listGifts()
      },
      async listGifts(){
        await this.getGifts()
      },
      formatPrice(value) {
        if(value == undefined){ value = 0 }
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async doSearch() {
        
        // evitar chamar a API 2x na montagem do componente
        if (!this.initialized) return
        
        try {

          this.dataTableLoading = true
          await this.getGifts( buildPayloadPagination(this.pagination, this.buildSearch()) )
          this.dataTableLoading = false

        } catch (error) {
          this.dataTableLoading = false
        }
      },
      buildSearch() {
        return this.search
          ? `?key=${this.search}`
          : ''
      }
    },
    mounted(){ this.initialized = true },

  }
</script>
